/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/crm-fetch-client";
import type { ReviewSuggestionMutationRequest, ReviewSuggestionMutationResponse, ReviewSuggestionPathParams, ReviewSuggestionHeaderParams, ReviewSuggestion401, ReviewSuggestion404, ReviewSuggestion409 } from "../../models/socialProfileSuggestionsController/ReviewSuggestion";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/crm-fetch-client";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const reviewSuggestionMutationKey = () => [{ url: '/social-profile-suggestions/:suggestionId' }] as const

export type ReviewSuggestionMutationKey = ReturnType<typeof reviewSuggestionMutationKey>

/**
 * {@link /social-profile-suggestions/:suggestionId}
 */
export async function reviewSuggestion(suggestionId: ReviewSuggestionPathParams["suggestionId"], data: ReviewSuggestionMutationRequest, headers?: ReviewSuggestionHeaderParams, config: Partial<RequestConfig<ReviewSuggestionMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ReviewSuggestionMutationResponse, ResponseErrorConfig<ReviewSuggestion401 | ReviewSuggestion404 | ReviewSuggestion409>, ReviewSuggestionMutationRequest>({ method : "PATCH", url : `/social-profile-suggestions/${suggestionId}`, data : requestData, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function reviewSuggestionMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ReviewSuggestionMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = reviewSuggestionMutationKey()
        return mutationOptions<ReviewSuggestionMutationResponse, ResponseErrorConfig<ReviewSuggestion401 | ReviewSuggestion404 | ReviewSuggestion409>, {suggestionId: ReviewSuggestionPathParams["suggestionId"], data: ReviewSuggestionMutationRequest, headers?: ReviewSuggestionHeaderParams}, TContext>({
          mutationKey,
          mutationFn: async({ suggestionId, data, headers }) => {
            return reviewSuggestion(suggestionId, data, headers, config)
          },
        })

}

/**
 * {@link /social-profile-suggestions/:suggestionId}
 */
export function useReviewSuggestion<TContext>(options: 
{
  mutation?: UseMutationOptions<ReviewSuggestionMutationResponse, ResponseErrorConfig<ReviewSuggestion401 | ReviewSuggestion404 | ReviewSuggestion409>, {suggestionId: ReviewSuggestionPathParams["suggestionId"], data: ReviewSuggestionMutationRequest, headers?: ReviewSuggestionHeaderParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ReviewSuggestionMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? reviewSuggestionMutationKey()

          const baseOptions = reviewSuggestionMutationOptions(config) as UseMutationOptions<ReviewSuggestionMutationResponse, ResponseErrorConfig<ReviewSuggestion401 | ReviewSuggestion404 | ReviewSuggestion409>, {suggestionId: ReviewSuggestionPathParams["suggestionId"], data: ReviewSuggestionMutationRequest, headers?: ReviewSuggestionHeaderParams}, TContext>
          

          return useMutation<ReviewSuggestionMutationResponse, ResponseErrorConfig<ReviewSuggestion401 | ReviewSuggestion404 | ReviewSuggestion409>, {suggestionId: ReviewSuggestionPathParams["suggestionId"], data: ReviewSuggestionMutationRequest, headers?: ReviewSuggestionHeaderParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ReviewSuggestionMutationResponse, ResponseErrorConfig<ReviewSuggestion401 | ReviewSuggestion404 | ReviewSuggestion409>, {suggestionId: ReviewSuggestionPathParams["suggestionId"], data: ReviewSuggestionMutationRequest, headers?: ReviewSuggestionHeaderParams}, TContext>
      
}